import { IconProps } from '@models/icons';

function LocationFill({ size = 16, color, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <path fillRule="evenodd" clipRule="evenodd"
                d="M2 7C2 3.68619 4.68619 1 8 1C11.3138 1 14 3.68619 14 7C14 7.98995 13.652 9.2739 13.2219 10.0939C12.1252 12.1846 8 15.5 8 15.5C8 15.5 3.87482 12.1846 2.77806 10.0939C2.34798 9.2739 2 7.98995 2 7ZM8 8.99999C9.10457 8.99999 10 8.10456 10 6.99999C10 5.89542 9.10457 4.99999 8 4.99999C6.89543 4.99999 6 5.89542 6 6.99999C6 8.10456 6.89543 8.99999 8 8.99999Z"
                fill={color}/>
        </svg>
    );
}

export default LocationFill;
